/**
 * PDP-Bildergalerie (mobil/tablet <900px): Scroll-Snap-Slider.
 * - Pfeile gehen zur vorigen/naechsten Slide, Endlos-Schleife (ANNAHME, siehe snippets/pdp-gallery.liquid),
 * - der Wechsel gleitet in die Richtung, in die der Nutzer geht (Alex, Pastel #27, 22.09.: "let the images
 *   slide into the direction the user is going instead of just abruptly showing the next image").
 *   Bei prefers-reduced-motion: reduce bleibt der Sprung ohne Bewegung.
 * - der aktive Punkt (Klasse + aria-current) folgt der Scroll-Position (Wischen, Pfeile, Punkte),
 * - Punkt-Klick scrollt direkt zum Bild.
 * Ab 900px ist die Galerie gestapelt, dieses Skript hat dort keine Wirkung (Track scrollt nicht).
 * - Nach dem Laden der Seite holt es alle Galeriebilder im Hintergrund (Alex, Pastel #48, 25.09.: "preload all
 *   images in the gallery once the initial page load is done"): loading="lazy" -> "eager", der Browser waehlt
 *   weiter die passende Groesse aus srcset/sizes. Nicht bei "Daten sparen" (Save-Data).
 */
(function () {
  document.querySelectorAll('.pdp-gallery').forEach(function (gallery) {
    var track = gallery.querySelector('.pdp-gallery__track');
    var slides = gallery.querySelectorAll('.pdp-gallery__slide');
    var dots = gallery.querySelectorAll('.pdp-gallery__dot');
    if (!track || !slides.length) return;

    function setActive(index) {
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('pdp-gallery__dot--active', on);
        if (on) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function current() {
      var w = slides[0].getBoundingClientRect().width || track.clientWidth;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
    }

    var noMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function goTo(index, smooth) {
      var n = slides.length;
      var i = ((index % n) + n) % n;
      var left = slides[i].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      track.scrollTo({ left: left, behavior: smooth && !noMotion.matches ? 'smooth' : 'auto' });
      setActive(i);
    }

    var pending = false;
    track.addEventListener(
      'scroll',
      function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          setActive(current());
        });
      },
      { passive: true },
    );

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i, true);
      });
    });

    gallery.querySelectorAll('[data-action]').forEach(function (button) {
      button.addEventListener('click', function () {
        var direction = button.getAttribute('data-action') === 'prev' ? -1 : 1;
        goTo(current() + direction, true);
      });
    });
  });

  function preloadAll() {
    var conn = navigator.connection;
    if (conn && conn.saveData) return;
    document.querySelectorAll('.pdp-gallery__image[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });
  }
  function afterLoad() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(preloadAll, { timeout: 2000 });
    else window.setTimeout(preloadAll, 200);
  }
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad, { once: true });
})();
